import React from 'react'
import createReactClass from 'create-react-class'
import ViewURLModalPanelContainer from '../../containers/view-url-modal-panel-container'

export default createReactClass({
  getInitialState () {
    return {
      showModal: false,
    }
  },
  onViewURLClick () {
    this.setState({
      showModal: true,
    })
  },
  closeModal () {
    this.setState({
      showModal: false,
    })
  },
  renderModalPanel () {
    if (this.state.showModal) {
      return (
        <ViewURLModalPanelContainer closeModal={this.closeModal}/>
      )
    }
    return false
  },
  render () {
    return (
      <div className='view-url-panel'>
        <button type='button' onClick={this.onViewURLClick} className="cs-grey-button" disabled={this.props.loader}>View URL</button>
        {this.renderModalPanel()}
      </div>
    )
  },
})



// WEBPACK FOOTER //
// ./src/components/view-url-button/view-url-panel.js